
export default {
  name: "ArtImportedFrom",
  props: ["label", "slug", 'hash']
}
